import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import MainContainer from './MainContainer';
import broadcastListService from '../../../../Report/transmissionList/service';
import { toast } from 'react-toastify';
import FlexChatIntegration from 'views/ServicePanel/components/QueueContent/components/Contact/service/FlexChatIntegration';

export const BroadcastListDashboard = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [name, setName] = useState('');

  const today = new Date();

  // Primeiro dia do mês atual
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

  // Formatar as datas como YYYY-MM-DD
  // const todayFormatted = today.toISOString().slice(0, 10);
  // const firstDayOfMonthFormatted = firstDayOfMonth.toISOString().slice(0, 10);

  const dataToSend = {
    idBroadCastList: id,
    // dateStart: '2022-01-01',
    // dateEnd: todayFormatted,
    reportType: 2
  };

  const getData = () => {
    FlexChatIntegration.getAllParams(1, 10, dataToSend, 2)
      .then((res) => {
        // console.log('res', res);
        if (
          res.data.data.GroupByStatusMessage.length === 0 &&
          res.data.data.groupByMessage.length === 0
        ) {
          toast.info('Nenhum registro foi encontrado');
        }
        setData([res.data.data]);
        setName(res.data.data.name);
      })
      .catch((err) => {
        console.log('err', err);
        toast.error(
          err || 'Ocorreu um erro porfavor entre em contato com o suporte'
        );
      });
  };

  useEffect(() => {
    getData();

    const interval = setInterval(() => {
      getData();
    }, 1000 * 20);

    return () => clearInterval(interval);
  }, [id]);

  return <MainContainer name={name} data={data} />;
};
